import {toast} from 'react-toastify';
import {deleteCookie} from '../../common/utils/CookieUtils';
import {logoutOperator} from '../../login/utils/LoginApi';

export async function get(url = '') {
  return handleErrorStatusCodes(await fetch(url));
}

export async function post(url = '', data = {}) {
  return handleErrorStatusCodes(await fetchWithBody(url, 'POST', data));
}

function handleErrorStatusCodes(response) {
  switch (response.status) {
  case 401:
    window.location.href = '/';
    deleteCookie('loggedInIndicator');
    throw new Error('user not authenticated.');
  case 403:
    toast.error('No permission - Click here to Logout', {
      onClick: async () => {
        await logoutOperator();
        window.location.href = '/';
      },
    });
    throw new Error('user does not have the permission to perform this action.');
  }
  return response;
}

function fetchWithBody(url = '', method, data = {}) {
  return fetch(url, {
    ...getDefaultOptions(),
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
}

function getDefaultOptions() {
  return {
    mode: 'same-origin',
  };
}


export async function getRecentPlayers(page = 0) {
  return (await get(`/api/players/recent?page=${page}`)).json();
}

export async function getPlayerAssignments() {
  return (await get('/api/player-assignments')).json();
}

export async function postPlayerAssignment(updatedAssignments) {
  return post('/api/player-assignments', updatedAssignments);
}
